module.exports = __webpack_public_path__ + "img/UT0379.99283837.png";